import { render, staticRenderFns } from "./HeaderAuth.vue?vue&type=template&id=3a304bd4&scoped=true&"
import script from "./HeaderAuth.vue?vue&type=script&lang=js&"
export * from "./HeaderAuth.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAuth.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HeaderAuth.vue?vue&type=style&index=1&id=3a304bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a304bd4",
  null
  
)

export default component.exports